import React from "react";
import { Grid, FormControl, TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function RangeSelector({ range, setRange, onLoad, onReset }) {
  // init internationalization
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} alignItems="center" sx={{ mb: 1, mt: 2 }}>
      <Grid item>
        <FormControl>
          <TextField
            label={t("range.StartIndex")}
            type="number"
            size="small"
            value={range.start}
            onChange={(e) =>
              setRange((prev) => ({
                ...prev,
                start: parseInt(e.target.value, 10),
              }))
            }
          />
        </FormControl>
      </Grid>
      <Grid item>
        <FormControl>
          <TextField
            label={t("range.EndIndex")}
            type="number"
            size="small"
            value={range.end}
            onChange={(e) =>
              setRange((prev) => ({
                ...prev,
                end: parseInt(e.target.value, 10),
              }))
            }
          />
        </FormControl>
      </Grid>
      <Grid item sx={{ display: "flex", gap: 1 }}>
        <Button onClick={onLoad} variant="outlined">
          {t("range.LoadRangeButton")}
        </Button>
        <Button onClick={onReset} variant="outlined" color="secondary">
          {t("range.ResetButton")}
        </Button>
      </Grid>
    </Grid>
  );
}
